import React, { Component } from 'react';
import './PollInfo.css';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../../shared/firebase';
import { BlockChainCountdown, ErrorMessage, Loading } from '../../shared/layout';

import { ParseContract } from '../../services/ParseContract';
import { getNetType, asciiToHex, utoa } from '../../services/utilities';
import { ContractError, ContractErrorType } from '../../utils';
import { testNetPollContractAddress, mainNetPollContractAddress, pollContractAbi } from '../../contractsData/pollContract';

const { connex } = window;

class PollInfoBase extends Component {

  state = {
    isProcessing: false,
    isProcessingContract: false,
    processingError: null,
    poll: null,
  }

  static cardStyle = {
    width: 'initial',
    minHeight: '120px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  }

  componentDidMount = () => {
    this.setState({ poll: this.props.poll })
  }

  publishPoll = (event) => {
    event.stopPropagation();
    const { poll } = this.state;
    const { name, description, questions } = poll;
    let net = 'TEST';

    if (!window.connex) {
      window.location.href = 'https://env.vechain.org/r/#' + encodeURIComponent(window.location.href);
      return;
    }

    this.setState({ isProcessing: true, processingError: null });

    getNetType()
      .then(netType => {
        net = netType
      })
      .then(() => this.props.firebase.publishPoll(this.props.poll.id, net))
      .then(() => {
        const address = net === 'MAIN' ? mainNetPollContractAddress : testNetPollContractAddress;
        const contract = new ParseContract(pollContractAbi, address, connex);
        const signingService = window.connex.vendor.sign('tx');
        const payload = JSON.stringify({ name, description, questions });

        const method = contract.getMethod('registerPoll');
        const clause = method.asClause(asciiToHex(poll.id), utoa(payload));

        return signingService.request([clause])
          .then(result => result.txid)
          .catch(err => {
            throw new ContractError(err && err.message);
          });
      })
      .then(txId => {
        this.setState({ isProcessingContract: true });
        return txId;
      })
      .then(txId => connex.thor.ticker().next().then(() => connex.thor.transaction(txId)))
      .then(transaction => transaction.getReceipt())
      .then(transactionReceipt => {
        if (!transactionReceipt) {
          throw new ContractError('Blockchain transaction timed out.');
        }
        if (transactionReceipt.reverted) {
          throw new ContractError('Blockchain transaction reverted.');
        }
      })
      .then(() => {
        this.setState({
          isProcessing: false,
          isProcessingContract: false,
          poll: { ...poll, published: true, net },
        }, () => this.props.history.push(`/panel/tokens/${this.props.poll.id}`));
      })
      .catch(err => {
        console.error(err);

        return (err && err.type === ContractErrorType ? this.props.firebase.unpublishPoll(this.props.poll.id) : Promise.resolve())
          .finally(() => {
            this.setState({
              isProcessing: false,
              poll: { ...poll, published: false, net: null },
              isProcessingContract: false,
              processingError: err ? err.message : 'GENERIC_ERROR',
            });
          });
      });
  };

  goToPoll = (event) => {
    event.stopPropagation();
    const { poll } = this.state;
    if (this.state.isProcessing) {
      return;
    }
    if (poll.published) {
      this.props.history.push(`/details/${poll.id}`);
    }
    if (!poll.published) {
      this.props.history.push(`/edit/${poll.id}`);
    }
  }

  getTokens = (event) => {
    event.stopPropagation();
    const { poll } = this.state;
    this.props.history.push(`/panel/tokens/${poll.id}`)

  }

  goToResults = (event) => {
    event.stopPropagation();
    const { poll } = this.state;
    this.props.history.push(`/details/${poll.id}`);
  }

  goToEdit = (event) => {
    event.stopPropagation();
    const { poll } = this.state;
    this.props.history.push(`/edit/${poll.id}`);
  }

  render() {
    const { isProcessing, isProcessingContract, processingError, poll } = this.state;

    return !poll ? null : (
      <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--6-col mdl-cell--12-col-tablet mdl-cell--6-col-desktop poll-card" onClick={(e) => this.goToPoll(e)}>
        <div className="mdl-card__title mdl-color--primary mdl-color-text--white" style={{justifyContent: 'space-between'}}>
          <h2 className="mdl-card__title-text" style={{lineHeight: '36px'}}>{poll.name}</h2>
          { !poll.published ? null : <span className={`mdl-chip ${poll.net === 'MAIN' ? 'mdl-color--red' : 'mdl-color--primary-dark'}`}>
            <span
              className="mdl-chip__text"
              style={{
                fontSize: '15px',
                fontWeight: '400',
                color: 'white',
              }}
            >{poll.net === 'MAIN' ? 'MainNet' : 'TestNet'}</span>
          </span> }
        </div>
        {
          isProcessing ? <div className="mdl-card__supporting-text mdl-color-text--grey-600" style={{margin: 'auto'}}>
            { isProcessingContract ? <BlockChainCountdown count={15} /> : <Loading /> }
          </div> :
          <div className="mdl-card__supporting-text mdl-color-text--grey-600" style={PollInfoBase.cardStyle}>
          <div>
            Description: {poll.description}
          </div>
          <div>
            Questions: {poll.questions ? poll.questions.length : 0}
          </div>
          {
            processingError ?
            <div>
              <ErrorMessage overrideStyles={{ padding: '4px', width: 'auto', height: 'auto' }} message={processingError} />
            </div> :
            null
          }
          <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center'}}>
            {
              poll.published ?
              <div>
               <button
                  className="mdl-button mdl-js-button mdl-button--colored"
                  onClick={(e) => this.goToResults(e)}
                >
                  Results
                </button>
              </div> : null
            }
            {
              poll.published ?
              <div>
               <button
                  className="mdl-button mdl-js-button mdl-button--colored"
                  onClick={(e) => this.getTokens(e)}
                >
                  Get Tokens
                </button>
              </div> : null
            }
            {
              !poll.published ?
              <div>
                <button
                  className="mdl-button mdl-js-button mdl-button--colored"
                  onClick={(e) => this.goToEdit(e)}
                >
                  Edit
                </button>
              </div> : null
            }
            {
              !poll.published ?
              <div>
                <button
                  className="mdl-button mdl-js-button mdl-button--colored"
                  onClick={(e) => this.publishPoll(e)}
                >
                  Publish
                </button>
              </div> : null
            }
          </div>
        </div>
        }
      </div>
    );
  }
};

export const PollInfo = compose(withRouter, withFirebase)(PollInfoBase);
